export default __webpack_public_path__ + "static/media/double-arrow-left.7e0a267a.svg";